import type { RentalManagerAuthCheckUserInfoWebApiDto } from '@zg-rentals/ts-rental-manager-api-beta-client';

type ListingProps = {
  customerId?: string | null;
  isRoomForRent?: boolean | string;
  isMultifamily?: boolean;
};

const enterpriseUtils = {
  getMustSetCustomerId: (
    listing: ListingProps,
    user: Pick<
      RentalManagerAuthCheckUserInfoWebApiDto,
      'isSingleFamilyEnterpriseCustomer' | 'isMultifamilyCustomer' | 'userManagementCompanyId'
    >,
    paidMultifamilyLocation = false,
    hasAnyExpiredContracts = false,
    hasActiveContracts = false,
  ) => {
    const { customerId, isRoomForRent, isMultifamily } = listing;
    const { isSingleFamilyEnterpriseCustomer, isMultifamilyCustomer, userManagementCompanyId } = user;

    if (!isSingleFamilyEnterpriseCustomer) {
      return false;
    }
    if (!userManagementCompanyId) {
      return false;
    }
    if (!hasActiveContracts && hasAnyExpiredContracts) {
      return false;
    }
    if (isRoomForRent && !isMultifamily) {
      return false;
    }
    if (isMultifamily && paidMultifamilyLocation && isMultifamilyCustomer) {
      return false;
    }
    return !customerId;
  },
};

export default enterpriseUtils;
